module.exports = __webpack_public_path__ + "static/media/sigmadental.2635af5d.svg";